// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-group .list-group-item {
  position: relative;
}
.list-group .list-group-item.expandable {
  padding-right: 40px;
}
.list-group .list-group-item .expand-collapse {
  position: absolute;
  right: 5px;
  top: 7px;
  font-size: 20px;
}
.list-group .list-group-item .expand-collapse .fa {
  font-weight: bold;
}

.list-group-detail {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  margin-bottom: -1px;
  padding-left: 35px;
}

.detail-section {
  margin-bottom: 20px;
}
.detail-section > div:first-of-type {
  font-weight: bold;
}
.detail-section.no-margin-bottom {
  margin-bottom: 0;
}

.collapsible-row {
  overflow: hidden;
}

.label.label-as-badge {
  display: inline-block;
  margin: 1px;
}`, "",{"version":3,"sources":["webpack://./src/app/U2000_shared/U2000_components/U2000_grid/U2000_grid.component.scss"],"names":[],"mappings":"AAEI;EACI,kBAAA;AADR;AAEQ;EAGI,mBAAA;AAFZ;AAKQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AAHZ;AAIY;EACI,iBAAA;AAFhB;;AAQA;EACI,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AALJ;;AAQA;EACI,mBAAA;AALJ;AAOI;EACI,iBAAA;AALR;AAQI;EACI,gBAAA;AANR;;AAUA;EACI,gBAAA;AAPJ;;AAUA;EACI,qBAAA;EACA,WAAA;AAPJ","sourcesContent":["\n.list-group {\n    .list-group-item {\n        position: relative;\n        &.expandable {\n            // SAIA-23489 : place reservee a la fleche (right 5px + icone ~25px) ; 22px ne suffisait plus\n            // depuis Bootstrap 5 (gouttiere .row/.col de 12px au lieu de 15px) : le montant touchait la fleche.\n            padding-right: 40px;\n        }\n\n        .expand-collapse {\n            position: absolute;\n            right: 5px;\n            top: 7px;\n            font-size: 20px;\n            .fa {\n                font-weight: bold;\n            }\n        }\n    }\n}\n\n.list-group-detail {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n    margin-bottom: -1px;\n    padding-left: 35px;\n}\n\n.detail-section {\n    margin-bottom: 20px;\n\n    > div:first-of-type {\n        font-weight: bold;\n    }\n\n    &.no-margin-bottom {\n        margin-bottom: 0;\n    }\n}\n\n.collapsible-row {\n    overflow: hidden;\n}\n\n.label.label-as-badge {\n    display: inline-block;\n    margin: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
